define(['../ApplicationFeatures'],
    ApplicationFeatures =>
        () => ({
            restrict: 'A',
            scope: {
                category: '@'
            },
            transclude: true,
            link: (scope, element, attrs, ctrl, transcludeFn) => {
                const enabled = ApplicationFeatures.hasFeature(scope.category);
                if (enabled) {
                    const content = transcludeFn();
                    element.append(content);
                }
            }
        })
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/featuredetection/directives/FeatureToggler.js